import React, { KeyboardEvent } from 'react'
import { saveAs } from 'file-saver'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { Icon, IconChoices } from '../Icon'
import { createUrl } from '../../../api/helpers'

interface MediaGalleryModalFooterProps {
  mediaId: string | undefined
}

export const MediaGalleryModalFooter = ({
  mediaId,
}: MediaGalleryModalFooterProps): JSX.Element => {
  const { translate } = useAppTranslation()

  const downloadImage = (): void => {
    mediaId && saveAs(createUrl(`/media/fetch/${mediaId}`), mediaId.slice(0, 7))
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      downloadImage()
    }
  }

  return (
    <div
      className="flex gap-2"
      role="button"
      aria-label="Download"
      onClick={downloadImage}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <p className="m-0">{translate('mediaGallery.downloadImageButtonText')}</p>
      <Icon icon={IconChoices.DOWNLOAD} highlighted />
    </div>
  )
}
